import { render, staticRenderFns } from "./uricAcid.vue?vue&type=template&id=5576b7d6&scoped=true"
import script from "./uricAcid.vue?vue&type=script&lang=js"
export * from "./uricAcid.vue?vue&type=script&lang=js"
import style0 from "./uricAcid.vue?vue&type=style&index=0&id=5576b7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5576b7d6",
  null
  
)

export default component.exports